import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

export const Navbar = () => {
  return (
    <nav className="w-full h-14 flex justify-center items-center sm:justify-between absolute z-10">
      <Link
        to="/"
        className="ml-0 mt-10 md:ml-12 outline-none h-full logo"
      ></Link>
    </nav>
  );
};
